enum ActionTypes {
    UpdateDotCommentReadStatus = "dotsComments/updateDotCommentReadStatus"
}

export default ActionTypes;
